import { render, staticRenderFns } from "./AuthenticationModal.vue?vue&type=template&id=5e864986&"
import script from "./AuthenticationModal.vue?vue&type=script&lang=js&"
export * from "./AuthenticationModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationModal.vue?vue&type=style&index=0&id=5e864986&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports